import { AppUser } from '../../../views/App/App';
import axios from 'Src/helpers/api/axiosInstance';

interface TournamentNotificationPayload {
  title: string;
  text: string;
  content?: {
    push?: {
      title?: string;
      body?: string;
    };
  };
  attachments?: Array<{
    fileName: string;
    fileSize?: number;
    externalFileId: string;
    link?: string;
  }>;
  schoolIds: string[];
  includeUnionAdmins?: boolean;
  recipientAudience?: 'ATHLETE_SCHOOLS';
}

function getConfig(user: AppUser) {
  const { roleSessionKey: key } = user;

  return {
    headers: { usid: key }
  };
}

export function getTournamentNotificationAthleteSchools(user: AppUser, tournamentId: string) {
  return axios.get(`${window.apiBase}/i/schools/${user.activeSchoolId}/tournaments/${tournamentId}/notifications/athleteSchools`, getConfig(user)).then(response => response.data);
}

export function createTournamentNotification(user: AppUser, tournamentId: string, data: TournamentNotificationPayload) {
  const { activeSchoolId } = user;
  const config = getConfig(user);

  return axios
    .post(`${window.apiBase}/i/schools/${activeSchoolId}/tournaments/${tournamentId}/notifications`, data, config)
    .then(response => {
      return response;
    });
}

export function updateTournamentNotificationDraft(
  user: AppUser,
  tournamentId: string,
  actionDescriptorId: string,
  data: TournamentNotificationPayload
) {
  const { activeSchoolId } = user;
  const config = getConfig(user);

  return axios
    .put(
      `${window.apiBase}/i/schools/${activeSchoolId}/tournaments/${tournamentId}/notifications/${actionDescriptorId}`,
      data,
      config
    )
    .then(response => {
      return response.data;
    });
}

export function sendTournamentNotificationNow(user: AppUser, tournamentId: string, actionDescriptorId: string) {
  const { activeSchoolId } = user;
  const config = getConfig(user);

  return axios
    .post(
      `${window.apiBase}/i/schools/${activeSchoolId}/tournaments/${tournamentId}/notifications/${actionDescriptorId}/send`,
      {},
      config
    )
    .then(response => {
      return response.data;
    });
}

export function getTournamentNotificationSchedule(user: AppUser, tournamentId: string, actionDescriptorId: string) {
  const { activeSchoolId } = user;
  const config = getConfig(user);

  return axios
    .get(
      `${window.apiBase}/i/schools/${activeSchoolId}/tournaments/${tournamentId}/notifications/${actionDescriptorId}/schedule`,
      config
    )
    .then(response => {
      return response.data;
    });
}

export function scheduleTournamentNotification(
  user: AppUser,
  tournamentId: string,
  actionDescriptorId: string,
  scheduleAt: string
) {
  const { activeSchoolId } = user;
  const config = getConfig(user);

  return axios
    .put(
      `${window.apiBase}/i/schools/${activeSchoolId}/tournaments/${tournamentId}/notifications/${actionDescriptorId}/schedule`,
      { scheduleAt },
      config
    )
    .then(response => {
      return response.data;
    });
}

export function unscheduleTournamentNotification(user: AppUser, tournamentId: string, actionDescriptorId: string) {
  const { activeSchoolId } = user;
  const config = getConfig(user);

  return axios
    .delete(
      `${window.apiBase}/i/schools/${activeSchoolId}/tournaments/${tournamentId}/notifications/${actionDescriptorId}/schedule`,
      config
    )
    .then(response => {
      return response.data;
    });
}
